// WizardCadenceSection — US-128 (campaign daily dispatch limit).
//
// Extracted verbatim from CreateWizard's inline "Section 4 — cadence" block.

import { useT } from '@barel/i18n';
import { Card } from '@barel/ui';

import { CadenceEditor } from '../CadenceEditor';

export interface WizardCadenceSectionProps {
  dailyLimit: number;
  onDailyLimitChange: (next: number) => void;
}

export function WizardCadenceSection({
  dailyLimit,
  onDailyLimitChange,
}: WizardCadenceSectionProps) {
  const t = useT('campaigns');
  return (
    <Card padding="lg" radius="2xl" data-testid="wizard-section-cadence">
      <div className="mb-3">
        <strong className="text-primary text-sm">{t('create.sectionCadence.title')}</strong>
        <p className="text-tertiary text-xs mt-1">{t('create.sectionCadence.sub')}</p>
      </div>
      <CadenceEditor dailyLimit={dailyLimit} onDailyLimitChange={onDailyLimitChange} />
    </Card>
  );
}
